var render, staticRenderFns
import script from "./Atomic.vue?vue&type=script&lang=js"
export * from "./Atomic.vue?vue&type=script&lang=js"
import style0 from "./Atomic.vue?vue&type=style&index=0&id=34fd89c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports